import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Link } from "gatsby";
import { FaFacebookSquare } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { SiHomify } from "react-icons/si";
import { SiHouzz } from "react-icons/si";
import {
  Ville,
  Rville,
  Rdepartement,
  Rregion,
  variablesSubstitution,
} from "../components/Variables";
import ReadMoreWhite from "../components/ReadMoreWhite";

const FooterComponent = ({ ...props }) => (
  <Footer>
    <Row>
      <Col1>
        <Title>
          <StyledLink to="/boutiques/">
            Nos adresses déco en Bretagne
          </StyledLink>
        </Title>

        <P>
          Retrouvez nos bonnes adresses déco <Rville /> et <Rdepartement />.
          Celles-ci vous permettent d’aménager votre intérieur dans le style qui
          vous correspond&nbsp;: design, contemporain, industriel, nature,
          scandinave, vintage ou classique. En faisant appel à nos décorateurs
          et architectes d'interieur pour votre projet d’architecture
          d’intérieur, vous bénéficiez parfois de tarifs préférentiels auprès de
          ces professionnels de la décoration <Rregion />.
        </P>

        <ReadMoreWhite
          link="/boutiques/"
          title={variablesSubstitution(
            "Découvrez nos bonnes adresses décoration d'intérieur rville"
          )}
        />
      </Col1>
      <Col2>
        <Title>Nous intervenons à… </Title>
        <Ul
          css={css`
            columns: 2;
            -webkit-columns: 2;
            -moz-columns: 2;
          `}
        >
          <Li>
            <A
              href="https://www.architectes-interieur-aix-en-provence.com/"
              title="Architecte d'intérieur à Aix-en-Provence"
              target="_blank"
              rel="noopener noreferrer"
            >
              Aix-en-Provence
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-annecy.com/"
              title="Architecte d'intérieur à Annecy"
              target="_blank"
              rel="noopener noreferrer"
            >
              Annecy
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-biarritz.com/"
              title="Architecte d'intérieur à Biarritz et dans le Pays basque"
              target="_blank"
              rel="noopener noreferrer"
            >
              Biarritz
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-bordeaux.com"
              title="Architecte d'intérieur à Bordeaux"
              target="_blank"
              rel="noopener noreferrer"
            >
              Bordeaux
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-bruxelles.com"
              title="Collectif d'architectes et décorateurs d'intérieur à Bruxelles"
              target="_blank"
              rel="noopener noreferrer"
            >
              Bruxelles
            </A>
          </Li>
          <Li>
            <A
              href="https://www.createursdinterieur.com/architecte-interieur-perche/"
              title="Architecte d'intérieur dans le Perche"
              target="_blank"
              rel="noopener noreferrer"
            >
              Le Perche
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-lille.fr"
              title="Collectif d'architectes et décorateurs d'intérieur à Lille"
              target="_blank"
              rel="noopener noreferrer"
            >
              Lille
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-lyon.com"
              title="Architecte d'intérieur à Lyon"
              target="_blank"
              rel="noopener noreferrer"
            >
              Lyon
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-marseille.com"
              title="Collectif d'architectes et décorateurs d'intérieur à Marseille"
              target="_blank"
              rel="noopener noreferrer"
            >
              Marseille
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-montpellier.com"
              title="Architectes d'intérieur à Montpellier"
              target="_blank"
              rel="noopener noreferrer"
            >
              Montpellier
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-nantes.com"
              title="Architecte d'intérieur à Nantes"
              target="_blank"
              rel="noopener noreferrer"
            >
              Nantes
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-nimes.com"
              title="Architecte d'intérieur à Nîmes"
              target="_blank"
              rel="noopener noreferrer"
            >
              Nîmes
            </A>
          </Li>
          <Li>
            <A
              href="https://www.createursdinterieur.com"
              title="Collectif des créateurs d'intérieur à Paris"
              target="_blank"
              rel="noopener noreferrer"
            >
              Paris
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architectes-interieur-bretagne.com/"
              title="Collectif des créateurs d'intérieur en Bretagne"
              target="_blank"
              rel="noopener noreferrer"
            >
              Quimper
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-var.com/"
              title="Architecte d'intérieur à Toulon et dans le Var 83"
              target="_blank"
              rel="noopener noreferrer"
            >
              Toulon
            </A>
          </Li>
          <Li>
            <A
              href="https://www.toulouse-architecte-interieur.com"
              title="Architecte d'intérieur à Toulouse"
              target="_blank"
              rel="noopener noreferrer"
            >
              Toulouse
            </A>
          </Li>
          <Li>
            <A
              href="https://www.architecte-interieur-tours.com/"
              title="Architecte d'intérieur à Tours et en Touraine"
              target="_blank"
              rel="noopener noreferrer"
            >
              Tours
            </A>
          </Li>
        </Ul>
      </Col2>
      <Col3>
        <Title>Et aussi… </Title>
        <Ul>
          <Li>
            <StyledLink to="/presse/">Revue de presse</StyledLink>
          </Li>
          <Li>
            <StyledLink to="/videos/">Vidéos</StyledLink>
          </Li>
          <Li>
            <StyledLink to="/temoignages-de-nos-clients/">
              Témoignages
            </StyledLink>
          </Li>
          <Li>
            <StyledLink to="/tarifs-architecte-interieur/">
              Tarifs de nos prestations
            </StyledLink>
          </Li>
          <Li>
            <StyledLink to="/faq/">Questions fréquentes</StyledLink>
          </Li>
          <Li>
            <StyledLink to="/recrutement/">Recrutement</StyledLink>
          </Li>
          <Li>
            <StyledLink to="/contact/">Contactez-nous</StyledLink>
          </Li>
        </Ul>
      </Col3>
    </Row>
    <Copyright>
      <CopyrightCol1>
        Créateurs d'intérieur <Ville /> © 2025 |{" "}
        <StyledLink to="/mentions-legales/">Mentions légales</StyledLink> |{" "}
        <StyledLink to="/cgu/">Conditions d'utilisation</StyledLink> |{" "}
        <Link to={props.pathEn}>
          <span role="img" aria-label="English version">
            🇬🇧&nbsp;
          </span>
          English version
        </Link>
      </CopyrightCol1>
      <CopyrightCol2>
        <Title
          css={css`
            margin-top: 8px;
            margin-bottom: 10px;
          `}
        >
          Sur les réseaux sociaux :
        </Title>
        <WrapperLogo>
          <LogoItem>
            <A
              href="https://www.facebook.com/createursdinterieurparis"
              title="Consulter le compte Facebook des Créateurs d'intérieur"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookSquare />
            </A>
          </LogoItem>
          <LogoItem>
            <A
              href="https://www.instagram.com/createursdinterieur/"
              title="Consulter le compte Instagram des Créateurs d'intérieur"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </A>
          </LogoItem>
          <LogoItem>
            <A
              href="https://www.youtube.com/@createursdinterieur"
              title="Consulter la chaine Youtube du collectif d'architecte d'intérieur Créateurs d'intérieur"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube />
            </A>
          </LogoItem>
          <LogoItem>
            <A
              href="https://www.houzz.fr/pro/createursdinterieur/createurs-d-interieur"
              title="Consulter le profil des Créateurs d'intérieur sur Houzz"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiHouzz />
            </A>
          </LogoItem>
          <LogoItem>
            <A
              href="https://www.homify.fr/experts/7801/createurs-d-interieur"
              title="Consulter le compte Homify du collectif d'architecte d'intérieur Créateurs d'intérieur"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiHomify />
            </A>
          </LogoItem>
        </WrapperLogo>
      </CopyrightCol2>
    </Copyright>
  </Footer>
);

const Footer = styled.footer`
  background-color: #7a9282;
  padding: 1em 0;
  position: relative;
  z-index: 10;
  a {
    color: white;
    opacity: 0.95;
    text-decoration: none;
  }

  max-width: 100%;
`;

const Row = styled.div`
  width: 1250px;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  @media only screen and (max-width: 1250px) {
    padding: 0 15px;
  }
  @media only screen and (max-width: 900px) {
    display: block;
  }
`;

const Col1 = styled.div`
  flex: 38%;

  padding-right: 30px;
  @media only screen and (max-width: 678px) {
    padding-right: 0;
  }
`;

const Col2 = styled.div`
  flex: 26%;
  padding-left: 25px;
  @media only screen and (max-width: 900px) {
    padding: 0;
  }
`;

const Col3 = styled.div`
  flex: 35%;
  padding-left: 12px;
  @media only screen and (max-width: 900px) {
    padding: 0;
  }
`;

const Title = styled.div`
  font-family: "Raleway", sans-serif;
  color: white;
  font-size: 23px;
  font-weight: 700;
  letter-spacing: 0.075em;
  margin: 0.7em 0 1em;
  @media only screen and (max-width: 768px) {
    font-size: 21px;
  }
`;

const P = styled.p`
  color: white;
  font-size: 0.95em;
  line-height: 1.65em;
  padding-right: 10px;
  margin-bottom: 5px;
`;

const Ul = styled.ul`
  padding-left: 2px;
  margin-bottom: 0;
  @media only screen and (max-width: 768px) {
    list-style-type: none;
    padding-left: 2px;
  }
`;

const Li = styled.li`
  color: white;
  margin-bottom: 3px;
  font-size: 0.95em;
  letter-spacing: 0.03em;
  font-weight: 500;
  list-style-type: none;
`;

const A = styled.a`
  color: white !important;
  text-decoration: none;
  border-bottom: none;
  transition: all 0.1s;
  padding: 0 0 3px 0;
  margin: 0;
  &:hover {
    opacity: 0.75;
    transition: all 0.1s;
  }
`;

const StyledLink = styled(Link)`
  color: white !important;
  text-decoration: none;
  border-bottom: none;
  transition: all 0.1s;
  padding: 3px 0 3px 0;
  margin: 0;
  &:hover {
    opacity: 0.65;
    transition: all 0.1s;
  }
`;

const WrapperLogo = styled.div`
  display: flex;
  padding-right: 110px;
  @media only screen and (max-width: 900px) {
    padding-right: 0;
  }
`;

const LogoItem = styled.div`
  flex: 25%;
  font-size: 2.25em;
  padding-top: 3px;
  @media only screen and (max-width: 768px) {
    font-size: 1.75em;
    text-align: center;
  }
`;

const Copyright = styled.div`
  display: flex;
  max-width: 1250px;
  width: 100%;
  margin: 0 auto;
  color: white;
  opacity: 0.9;
  font-size: 0.8em;
  font-weight: 600;
  letter-spacing: 0.03em;
  padding-bottom: 10px;
  @media only screen and (max-width: 1250px) {
    padding: 0 15px;
  }
  @media only screen and (max-width: 900px) {
    margin-top: 1.5em;
    line-height: 1.5em;
    flex-direction: column;
  }
`;

const CopyrightCol1 = styled.div`
  flex: 65%;
  align-self: flex-end;
  padding-bottom: 12px;
  @media only screen and (max-width: 900px) {
    margin-top: 15px;
    flex: 100%;
    order: 2;
  }
`;

const CopyrightCol2 = styled.div`
  flex: 35%;
  @media only screen and (max-width: 900px) {
    flex: 100%;
    order: 1;
  }
`;

export default FooterComponent;
